import { arrayOf, params, shape, string } from '@thd-nucleus/data-sources';

export const dataModel = {
  product: params({
    itemId: string().isRequired()
  }).shape({
    itemId: string(),
    dataSource: string(),
    identifiers: shape({
      itemId: string(),
      canonicalUrl: string(),
      productLabel: string(),
      brandName: string(),
      modelNumber: string(),
      productType: string()
    }),
    taxonomy: shape({
      breadCrumbs: arrayOf(
        shape({
          label: string(),
          url: string(),
          browseUrl: string(),
          creativeIconUrl: string(),
          deselectUrl: string(),
          dimensionName: string(),
          refinementKey: string()
        })
      )
    }),
    specificationGroup: arrayOf(shape({
      specTitle: string(),
      specifications: arrayOf(shape({
        specName: string(),
        specValue: string()
      }))
    })),
    info: shape({
      classNumber: string(),
      subClassNumber: string()
    }),
    keyProductFeatures: shape({
      keyProductFeaturesItems: arrayOf(
        shape({
          features: arrayOf(
            shape({
              name: string(),
              value: string()
            })
          )
        }))
    })
  }),
  searchModel: params({
    navParam: string()
  })
    .shape({
      id: string(),
      metadata: shape({
        canonicalUrl: string(),
        clearAllRefinementsURL: string(),
        h1Tag: string()
      }),
      taxonomy: shape({
        breadCrumbs: arrayOf(
          shape({
            label: string(),
            url: string(),
            browseUrl: string(),
            creativeIconUrl: string(),
            deselectUrl: string(),
            dimensionName: string(),
            refinementKey: string()
          })
        )
      }),
      products: arrayOf(
        shape({
          info: shape({
            classNumber: string(),
            subClassNumber: string()
          })
        })
      )
    })
};
